var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": "",
            id: "editOrganicSocialMediaPlanModal",
            title: "Edit Organic Social Media Plan"
          },
          on: {
            hide: _vm.editOrganicSocialModalPlanHidden,
            shown: _vm.pushRoute,
            hidden: _vm.editOrganicSocialModalPlanHiddenComplete
          }
        },
        [
          _c("EditOrganicSocialMediaPlanModal", {
            ref: "refEditOrganicSocialMediaPlanModal",
            attrs: { tabIndex: _vm.tabIndex, namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.systemSettingsReady
        ? _c("RelatedDeliverablesSchedule", {
            key: "sms-rds",
            ref: "refRelatedDeliverablesSchedule",
            attrs: {
              parentDeliverableId: _vm.parentDeliverableId,
              namespace: _vm.namespace,
              tabTitle: "scheduled-content",
              showLogo: true,
              openedDirectlyWithModal: _vm.openedDirectlyWithModal
            },
            on: {
              resetOpenedDirectly: function($event) {
                _vm.openedDirectlyWithModal = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }